<template>
  <div>
    <hr>
    <div class="mb-3">
      <table class="tablaBusqueda">
        <tr>
          <td>
            <button type="submit" class="btn btn-light" data-bs-toggle="modal" data-bs-target="#ventanaModal"
              @click="abrirModalCrear" title="Nuevo registro">
              <i class="material-icons" style="font-size:24px;color:green; cursor: pointer;">add_box</i>
            </button>
          </td>
        </tr>
      </table>
    </div>
    <table class="table table-striped" id="sampleTable">
      <thead>
        <tr>
          <th scope="col"></th>
          <th scope="col"></th>
          <th scope="col">Tipo</th>
          <th scope="col">Descripción</th>
          <th scope="col">Fecha Reg.</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="tratamiento in datosPaginados" :key="tratamiento.idTratamiento">
          <td><i class="material-icons" style="font-size:16px;color:orangered; cursor: pointer;" @click="abrirModalEditar(tratamiento.idTratamiento)" title="Editar">edit_square</i></td>
          <td><i class="material-icons" style="font-size:16px;color:orangered; cursor: pointer;" @click="abrirEditar(tratamiento.idTratamiento)" title="Editar">edit_square</i></td>
          <td>{{this.descTipoTratamiento(tratamiento.tipo)}}</td>
          <td>{{tratamiento.observacion}}</td>
          <td>{{getFormattedDate(tratamiento.atencionFechaReg, 'DD/MM/YYYY')}}</td>
          <td><i class="material-icons" style="font-size:16px;color:red; cursor: pointer;" @click="deleteTratamiento(tratamiento.idTratamiento)" title="Borrar">delete</i></td>
        </tr>
      </tbody>
    </table>
    <nav aria-label="Page navigation example">
      <ul class="pagination">
        <li class="page-item" v-on:click="getPreviousPage()"><a class="page-link" href="#">Anterior</a></li>
        <li id="lugar" v-for="pagina in totalPaginas()" v-bind:key="pagina" v-on:click = "getDataPagina(pagina)" class="page-item" v-bind:class="isActive(pagina)"><a class="page-link" href="#">{{pagina}}</a></li>
        <li class="page-item" v-on:click="getNextPage()"><a class="page-link" href="#">Siguiente</a></li>
      </ul>
    </nav>
<!-- Modal -->
<div class="modal fade" id="ventanaModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" v-if="modalWindow">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header bg-primary">
        <h5 class="modal-title" id="exampleModalLabel">
          <i class="fa fa-user-plus"></i> {{titulo}}</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
        </button>
      </div>
      <form>
        <div class="modal-body">
            <div class="mb-3" v-if="btnEditar">
              <div class="row">
                <div class="col-2">
                  <label for="idTratamiento" class="form-label">IdTratamiento</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idTratamiento" name="idTratamiento" v-model="datoTratamiento.idTratamiento" disabled>
                </div>
              </div>
            </div>
<!-- Botón Lista de Valores  Atencion -->
<!--
            <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="idAtencion" class="form-label"> Atencion</label>
                  </div>
                  <div class="col-10">
                    <select class="form-control" id="idAtencion" name="idAtencion" v-model="datoTratamiento.idAtencion">
                      <option v-for="atencion in atencions" :value="atencion.idAtencion" :key="atencion.idAtencion">
                        {{ atencion.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
            </div>
-->
<!-- Botón Lista de Valores  Atencion -->
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="tipo" class="form-label">Tipo</label>
                </div>
                <div class="col-10">
                  <select class="form-control" id="tipo" name="tipo" v-model="datoTratamiento.tipo" required>
                    <option value="" disabled selected>Seleccione una opción</option>
                    <option value="D">Diagnóstico</option>
                    <option value="T">Terapéutico</option>
                    <option value="E">Educacional</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="observacion" class="form-label">Observación</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="observacion" name="observacion" v-model="datoTratamiento.observacion" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
          </div>
      </form>
      <div class="modal-footer">
<!--
        <div class="me-auto">
          <button type="button" id="send" class="btn btn-light" data-bs-dismiss="modal" title="Cerrar">
            <i class="material-icons" style="font-size:32px;color:orangered; cursor: pointer;">meeting_room</i>
          </button>
        </div>
-->
        <button type="submit" class="btn btn-light" @click.prevent="guardarTratamiento" v-if="btnCrear" title="Guardar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">save</i>
        </button>
        <button type="submit" class="btn btn-light" @click.prevent="guardarEditTratamiento" v-if="btnEditar" title="Actualizar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">update</i>
        </button>
      </div>
    </div>
  </div>
</div>
  </div>
</template>
<script>
import { validarForm } from '@/modules/validacionesForms.js'
import dateFormat from '@/modules/dateFormat.js';
import { decodificarTipoTratamiento } from '@/modules/decode.js'

import api from "@/services/api";
import * as $ from 'jquery';
window["$"] = $;
window["jQuery"] = $;
import swal from  'sweetalert'
export default {
  props: {
    p_idAtencion: {
      type: Number,
      required: true
    }
  },
  components : {
  },
  data () {
    return {
      tratamientos : [],
      datoTratamiento : {},
      nombreBusqueda: '',
      titulo: '',
      btnCrear: false,
      btnEditar: false,
      elementosPorPagina: 10,
      datosPaginados: [],
      paginaActual: 1,
      modalWindow: true,
      atencions: [],
      showModalHelp: false,
      estiloImagen: {
        width: "200px",
        height: "200px"
      }
    }
  },
  mounted () {
    this.getDataPaginaTodos(this.paginaActual)
    this.fetchAtencions()
  },
  methods : {
    descTipoTratamiento(codigo) {
      return decodificarTipoTratamiento(codigo);
    },
    getFormattedDate(date) {
      return dateFormat.getFormattedDate(date);
    },
    totalPaginas(){
      return Math.ceil(this.tratamientos.length / this.elementosPorPagina)
    },
    getDataPagina(noPagina){
      if(this.nombreBusqueda != '') {
        api.get('/vwtratamientos/nombre/'+this.nombreBusqueda).then(response=>{
          this.tratamientos=response.data.reverse();  
          this.paginaActual = noPagina;
          this.datosPaginados = [];
          let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
          let fin = (noPagina * this.elementosPorPagina);
          this.datosPaginados = this.tratamientos.slice(ini,fin);
        });
      }
    },
    getDataPaginaTodos(noPagina){
      api.get('/vwtratamientos/idatencion/'+this.p_idAtencion).then(response=>{
      this.tratamientos=response.data.reverse();  
      this.paginaActual = noPagina;
      this.datosPaginados = [];
      let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
      let fin = (noPagina * this.elementosPorPagina);
      this.datosPaginados = this.tratamientos.slice(ini,fin);
       });
    },
    getPreviousPage(){
      if(this.paginaActual > 1){
        this.paginaActual--;
      }
      this.getDataPagina(this.paginaActual);
    },
    getNextPage(){
      if(this.paginaActual < this.totalPaginas()){
        this.paginaActual++;
      }
      this.getDataPagina(this.paginaActual);
    },
    isActive(noPagina){
      return noPagina == this.paginaActual ? 'active' : ''
    },
    validarForm(){
      const requiredFields = [
        'tipo'
        ,'observacion'
      ];
      const requiredFieldsText = [
        'tipo'
        ,'observacion'
      ];
      return validarForm(this.datoTratamiento, requiredFields, requiredFieldsText);
    },
    async guardarTratamiento(){
      if(this.validarForm() === 1){
        try {
          this.datoTratamiento.idAtencion = this.p_idAtencion;
          await api.post('/tratamientos', this.datoTratamiento)
          $('#ventanaModal').modal('hide');
          swal("Correcto!", "Tratamiento creada exitosamente!", "success");
          this.getDataPagina(this.paginaActual);
        } catch (error) { 
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    },
    async guardarEditTratamiento(){
      if(this.validarForm() === 1){
        try {
          await api.post('/tratamientos', this.datoTratamiento)
          $('#ventanaModal').modal('hide');
          this.getDataPagina(this.paginaActual);
          swal("Correcto!", "Tratamiento creado(a) exitosamente!", "success");
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
          var array = Object.values(error.response.data.errors)
          array.forEach(element => swal(String(element)))
        }
      }
    },
    abrirModalCrear(){
      this.modalWindow = true
      this.datoTratamiento={}
      this.titulo   = 'Crear Atención: Tratamiento'
      this.btnCrear = true
      this.btnEditar= false
    },
    abrirModalEditar(idTratamiento){
      this.modalWindow = true
      if(idTratamiento != null){    
           api.get('/vwtratamientos/'+idTratamiento).then(resp=>{
          this.datoTratamiento = resp.data;
           });
      }
      $('#ventanaModal').modal('show');
      this.titulo   = 'Editar Atención: Tratamiento'
      this.btnCrear = false
      this.btnEditar= true
    },
    abrirEditar(idTratamiento){
      if(idTratamiento != null){
        this.$router.push('/tratamientoform/'+idTratamiento)
      }
    },
    async deleteTratamiento (idTratamiento) {
      try{
        await api.delete('/tratamientos/'+idTratamiento)
          this.getDataPagina(this.paginaActual);
      }catch(error){
        alert('No se pudo eliminar')
      }
    },
    fetchAtencions() {
      fetch('http://localhost:8080/api/v1/atencions')
        .then(response => response.json())
        .then(data => {
          this.atencions = data;
        })
        .catch(error => {
          console.error('Error fetching atencions:', error);
        });
    },
  },
}
</script>
<style src="@/assets/css/listaFiltrada.css" scoped></style>
